import { createReducer, on, createFeatureSelector } from '@ngrx/store';
import { InvitationSearch } from '../models/invitation.model';
import { setInvitationsSearch } from '../actions/invitations-search.actions';

export const initialState: InvitationSearch = null;

const reducer = createReducer(initialState,
  on(setInvitationsSearch, (state, invitationsSearch) => invitationsSearch)
);

export const fromInvitationsSearch = {
  selectInvitationsSearchState: createFeatureSelector<InvitationSearch>('invitationsSearch'),
};

export function invitationsSearchReducer(state, action) {
  return reducer(state, action);
}
